import(/* webpackMode: "eager", webpackExports: ["Skeleton"] */ "__barrel_optimize__?names=Skeleton!=!/root/iyiwutrade/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/app/(industrialBelt)/industrialBelt/ClientWrapper.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/src/app/(industrialBelt)/industrialBelt/index.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/components/DataBoundary/index.js");
